<template>
    <div
        ref="column"
        class="flex-1 space-y-6 p-6"
        :style="style"
    >
        <slot />
    </div>
</template>

<script>
export default {
    name: 'FeConfiguratorColumn',
    data() {
        return {
            style: {},
            resizeHandler: null,
        };
    },
    mounted() {
        this.makeWidthFixed();
        this.resizeHandler = this.debounce(this.makeWidthFixed, 100);
        window.addEventListener('resize', this.resizeHandler);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.resizeHandler);
    },
    methods: {
        makeWidthFixed() {
            this.style = {};
            this.$nextTick(() => {
                if (!this.$refs.column) return;
                const width = this.$refs.column.clientWidth;
                this.style = { width: `${width}px` };
            });
        },
        debounce(func, wait) {
            let timeout;
            return (...args) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), wait);
            };
        },
    },
};
</script>
